import React from 'react';

const TicketStatus = ({update}) => {
    console.log(update)
    return (<div className={"display-flex"}>
            <span
                className="ticket-status-historic-span flex-2 display-flex justify-content-space-between align-items-baseline">
                <strong
                    className="ticket-status ticket-span-alias p-5-10"
                    style={{border: `solid 2px ${update.past_update_color}`, maxWidth: 170, color: `${update.past_update_color}`}}>
                    {update.past_update_name}
                </strong>

                <span className="m-10 display-flex justify-content-center flex-1 ticket-status-historic-icon">
                    <i className="fa-regular fa-angle-right color-third"/>
                </span>
                <strong
                    className="ticket-status ticket-span-alias p-5-10"
                    style={{border: `solid 2px ${update.new_update_color}`, maxWidth: 170, color: `${update.new_update_color}`}}>
                    {update.new_update_name}
                </strong>
            </span>
        </div>);
};

export default TicketStatus;